import React from "react";
import "./ActionInfoPopup.scss";
import Modal from '../WebChat/Common/Modal';
import OutsideClickHandler from "react-outside-click-handler";
import PropTypes from "prop-types";
import { ClosePopup } from "../../assets/images";
import Button from "../../ui/Button";

const ActionInfoPopup = (props = {}) => {
    const {
        textInfo = "",
        children = "",
        textHeading = "",
        textActionBtn = "",
        jestActionBtn = "",
        jestCancelBtn = "",
        textCancelBtn = "",
        btnCancelClass = "",
        btnActionClass = "",
        handleCancel = () => { },
        handleAction = () => { },
    } = props;

    return (

        <Modal containerId="container">
            <div className="action_poppup_wraper">
                <OutsideClickHandler onOutsideClick={handleCancel}>
                    <div className="action_poppup_inner">
                        <div className="action_poppup_label">
                            <div className="popup_close">
                                <h4>{textHeading}</h4>
                                <i onClick={handleCancel}>
                                    <ClosePopup />
                                </i>
                            </div>
                            <label>{textInfo}</label>
                        </div>

                        {children}
                        <div className="action_poppup_noteinfo">
                            {textCancelBtn &&
                                <Button
                                    variant="ghost"
                                    type="button"
                                    className={`btn-cancel ${btnCancelClass}`}
                                    data-id={jestCancelBtn}
                                    onClick={handleCancel}>
                                    {textCancelBtn}
                                </Button>
                            }
                            {textActionBtn &&
                                <Button
                                    variant="primary"
                                    type="button"
                                    className={`btn-action  ${btnActionClass}`}
                                    data-id={jestActionBtn}
                                    onClick={(e) => handleAction(e)}>
                                    {textActionBtn}
                                </Button>
                            }
                        </div>
                    </div>
                </OutsideClickHandler>
            </div>
        </Modal>
    );
};
export default ActionInfoPopup;

ActionInfoPopup.propTypes = {
    textInfo: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    textHeading: PropTypes.string,
    textActionBtn: PropTypes.string,
    textCancelBtn: PropTypes.string,
    btnCancelClass: PropTypes.string,
    btnActionClass: PropTypes.string,
    handleCancel: PropTypes.func,
    handleAction: PropTypes.func,
    children: PropTypes.node,
    jestActionBtn: PropTypes.string,
    jestCancelBtn: PropTypes.string,
};
